export default {
  title: 'Coordonnées',
  form: {
    customer_first_name: {
      placeholder: 'Prénom',
    },
    customer_last_name: {
      placeholder: 'Nom',
    },
    customer_email: {
      placeholder: 'Adresse e-mail',
    },
    customer_phone_number: {
      placeholder: 'Numéro de téléphone',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Veuillez entrer votre prénom',
    },
    customer_last_name: {
      required: 'Veuillez entrer votre nom',
    },
    customer_email: {
      required: 'Veuillez entrer votre e-mail',
    },
    customer_phone_number: {
      required: 'Veuillez entrer votre numéro de téléphone',
    },
  },
};
